exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dt-action-btns button.ui.button{padding:8px}.dt-action-btns button.ui.button>i.icon{margin:auto!important}.actionIcon{cursor:pointer}", ""]);

// exports
